import React from 'react';
import PageTemplate from '@page/iyagigo/page-template';
import Worksheet from '@component/iyagigo/worksheet';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import * as color from '@constant/color';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';

const WorksheetPage: React.FC = () => {
  const dispatch = useTypedDispatch();
  const handleBackClick = () => {
    dispatch(modalActions.showDialogModal({
      type: 'workbook-quit',
      data: { mainMenu: 'home', nextPath: IYAGIGO_PATH.HOME_BEGIN_PATH },
    }));
  };
  return <PageTemplate title='알짜 학습지' mode='back' backgroundColor={color.WHITE_1}
    handleNavigationClick={handleBackClick}>
    <Worksheet />
  </PageTemplate>;
};

export default WorksheetPage;
